/**
 * Configuration des langues pour le composant barre de recherche
 * Ce fichier peut être facilement modifié pour ajouter, supprimer ou mettre à jour les options de langue
 */
export const defaultLanguages = [
  {
    code: 'fr',
    label: 'FR',
    name: 'Français',
    icon: "/wp-content/themes/ans/public/images/flags/fr.svg",
    default: true
  },
  {
    code: 'en',
    label: 'EN',
    name: 'English',
    icon: "/wp-content/themes/ans/public/images/flags/gb.svg",
    default: false
  },
  {
    code: 'all',
    label: 'TOUTES',
    name: 'Toutes les langues',
    icon: "/wp-content/themes/ans/public/images/flags/all.svg",
    isAllLanguages: true,
    default: false
  },
];


/**
 * Fonction utilitaire pour obtenir la langue par défaut d'un tableau de langues
 * @param {Array} languages - Tableau d'objets langue
 * @returns {Object|null} - Objet langue par défaut ou première langue si aucune par défaut trouvée
 */
export function getDefaultLanguage(languages) {
  const defaultLang = languages.find(lang => lang.default === true);
  return defaultLang || languages[0] || null;
}




/**
 * Vérifie si une langue correspond à l'option "toutes les langues"
 * @param {Object} language - Objet langue à vérifier
 * @returns {boolean} - Vrai si c'est l'option "toutes les langues"
 */
export function isAllLanguagesOption(language) {
  if (!language) return false;
  return language.isAllLanguages === true || language.code === 'all';
}

/**
 * Vérifie si le code de langue correspond à "toutes les langues"
 * @param {string} languageCode - Code de langue à vérifier
 * @returns {boolean} - Vrai si c'est le code pour "toutes les langues"
 */
export function isAllLanguagesCode(languageCode) {
  return languageCode === 'all';
}
